import { Reveal } from "./Reveal";
import { usePerspective } from "@/context/PerspectiveContext";
import { getContent } from "@/content/perspectives";

const ProblemSection = () => {
  const { perspective } = usePerspective();
  const { problem } = getContent(perspective);
  if (!problem) return null;

  return (
    <section id="problem" data-testid="problem-section" className="bg-[#f5f7fb] px-6 py-28 lg:px-12 lg:py-40">
      <div className="mx-auto max-w-[1500px]">
        <Reveal>
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-cobalt">
            {problem.overline}
          </span>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-4xl font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
            {problem.titleTop}<br />
            <span className="italic text-cobalt">{problem.titleItalic}</span>
          </h2>
        </Reveal>

        <div className="mt-16 divide-y divide-black/10 border-t border-black/10">
          {problem.items.map((p, i) => (
            <Reveal key={p.no} delay={i * 0.06}>
              <div className="group relative grid grid-cols-1 gap-4 py-10 sm:grid-cols-12" data-testid={`problem-item-${p.no}`}>
                <span
                  className="absolute bottom-0 left-0 h-[2px] w-full origin-left scale-x-0 bg-cobalt transition-transform duration-500 group-hover:scale-x-100"
                  aria-hidden="true"
                />
                <div className="sm:col-span-2">
                  <span className="font-serif text-4xl font-medium text-cobalt/25 transition-colors duration-300 group-hover:text-cobalt">
                    {p.no}
                  </span>
                </div>
                <div className="sm:col-span-4">
                  <h3 className="font-serif text-2xl font-medium leading-tight text-ink transition-transform duration-300 group-hover:translate-x-1 lg:text-3xl">
                    {p.title}
                  </h3>
                </div>
                <div className="sm:col-span-6">
                  <p className="max-w-xl text-base font-light leading-relaxed text-ink/60">{p.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p
            data-testid="problem-closing"
            className="mt-16 max-w-3xl border-l-2 border-cobalt pl-6 font-serif text-2xl italic leading-snug text-ink lg:text-3xl"
          >
            {problem.closing}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default ProblemSection;
